import Swiper from 'swiper/bundle';

export default () => {
    const timelineEl = document.querySelector('.js-swiper-timeline');
   
    if (timelineEl) {  
      const timelineSlides = timelineEl.querySelectorAll('.js-timelineslide');
      new Swiper(timelineEl, {
        slidersPerView: 1,
        effect: "fade",
        speed: 1500,
        fadeEffect: {
          crossFade: true,
          transformEl: '.TimelineSlide',
        },
        // autoplay: {
        //   disableOnInteraction: false,
        //   pauseOnMouseEnter: false,
        //   delay: 4000,
        // },
        navigation: {
          nextEl: '.Swiper__ArrowNext',
          prevEl: '.Swiper__ArrowPrev',
        },
        pagination: {
          el: ".js-swiper-timeline-pagination", 
          clickable: true,
          renderBullet: function (index, className) {
            return `<div class="Swiper__PaginationItem ${className}">
              <span class="Swiper__PaginationItemLabel">${timelineSlides[index].dataset.bulletName}</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.5 43">
                <path fill="#000" d="M9.079 26.705a6 6 0 0 1 0-10.41L28.516 5.151a6 6 0 0 1 8.984 5.205v22.288a6 6 0 0 1-8.984 5.205Z"/>
              </svg>
            </div>`;
          },
        },
      });

      
    }

    
}